import {
  File,
  FileDoc,
  FilePdf,
  FilePpt,
  FileText,
  FileXls,
  MicrosoftExcelLogo,
  MicrosoftPowerpointLogo,
  MicrosoftWordLogo,
} from '@phosphor-icons/react'

/**
 * Enum for the MIME Types icons.
 * @readonly
 * @enum {import("@phosphor-icons/react").Icon}
 */
export const MimeTypes = {
  default: File,
  pdf: FilePdf,
  ppt: FilePpt,
  ppts: MicrosoftPowerpointLogo,
  pptx: MicrosoftPowerpointLogo,
  xls: FileXls,
  xlsx: MicrosoftExcelLogo,
  doc: FileDoc,
  docx: MicrosoftWordLogo,
  txt: FileText,
}
